<nb-card style="height: 350px;">
    <nb-card-header class="title-dialog">
        <h3 h3 style="color: white;">Creación de Usuario: {{nombreDeUsuario}}</h3>
    </nb-card-header>
    <nb-card-body>
        <p-dropdown required class="limited-selector" id="dropdownPerf" placeholder="Perfil"
            [style]="{'width':'100%','margin-bottom':'10px', 'margin-top':'10px'}" [options]="perfiles"
            [(ngModel)]="perfilSelected" [virtualScroll]="true" [itemSize]="10" [filter]="true" scrollHeight="90px">
        </p-dropdown>
        <br>
        <br>
        <br>
        <mat-form-field class="altaLabel" style="width: 29%; margin-right: 1%;">
            <mat-label>Apellido</mat-label>
            <input matInput #ApeInput type="text" [(ngModel)]="apellido" name="apellido">
        </mat-form-field>
        <mat-form-field class="altaLabel" style="width: 29%; margin-right: 1%;">
            <mat-label>Nombre</mat-label>
            <input matInput #nombreInput type="text" [(ngModel)]="nombre" name="nombre">
        </mat-form-field>
        <mat-form-field class="altaLabel" style="width: 30%;">
            <mat-label>Correo Electrónico</mat-label>
            <input matInput #emailInput type="text" [(ngModel)]="email" name="email">
        </mat-form-field>
    </nb-card-body>
    <nb-card-footer>
        <button nbButton size="tiny" style="float: right; margin-top: 5px;" class="buttontz"
            (click)="saveChangeUsuario(usuarioAEditar)" [disabled]="!cargoPerfiles">Guardar</button>
        <button nbButton size="tiny" class="buttontz col-2 float-left margin-right"
            (click)="cerrarModal()">Cancelar</button>
    </nb-card-footer>
</nb-card>
<ng-template #MSJConfirmaCancelarEDIT>
    <nb-card>
        <nb-card-header>
            Confirmación
        </nb-card-header>
        <nb-card-body>
            ¿Está seguro que desea guardar los cambios?
        </nb-card-body>
        <nb-card-footer>
            <nb-card-footer>
                <app-spinner *ngIf="showSpinner"></app-spinner>
                <button nbButton *ngIf="!showSpinner" size="tiny" style="float: right; margin-top: 5px;"
                    class="buttontz" (click)="saveEditUsuario()">Sí<nb-icon nbPrefix icon="checkmark-outline"
                        pack="eva"></nb-icon></button>
                <button nbButton *ngIf="!showSpinner" size="tiny" class="buttontz col-2 float-left margin-right"
                    (click)="hideConfirm()">No<nb-icon nbPrefix icon="close-outline" pack="eva"></nb-icon></button>
            </nb-card-footer>
        </nb-card-footer>
    </nb-card>
</ng-template>